<template>
    <div id="home">
        <div class="form-box">
            <el-form :inline="true"
                     :model="formSearch"
                     class="demo-form-inline">
                <el-form-item label="书本名称">
                    <el-input v-model="formSearch.book_name"
                              clearable
                              size="medium"
                              placeholder="请输入书本名称"></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input v-model="formSearch.check_code"
                              clearable
                              size="medium"
                              placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="formSearch.phone"
                              clearable
                              size="medium"
                              placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item label="是否使用">
                    <el-select v-model="formSearch.isused" clearable size="medium" placeholder="请选择书本名称">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"
                               plain
                               size="medium"
                               @click="search(1)">查询</el-button>
                    <el-button size="medium"
                               @click="reset">重置</el-button>
                    <el-button size="medium"
                                type="text" 
                                @click="statisticsDialog = true">统计</el-button>
                </el-form-item>
                <el-form-item class="fr">
                    <el-button type="primary"
                               @click="add">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-box">
            <el-table :data="tableData"
                      border
                      size="mini"
                      :height="tableHeight"
                      :max-height="tableHeight"
                      v-loading="loading"
                      stripe
                      show-overflow-tooltip>
                <el-table-column prop="book_name"
                                 label="书本名称">
                </el-table-column>
                <el-table-column prop="code"
                                 label="验证码">
                </el-table-column>
                <el-table-column prop="isused"
                                 label="是否使用">
                </el-table-column>
                <el-table-column prop="check_time"
                                 label="使用时间">
                </el-table-column>
                <el-table-column prop="receiver_phone"
                                 label="电话">
                </el-table-column>
                <el-table-column prop="receiver_openid"
                                 show-overflow-tooltip
                                 label="openId">
                </el-table-column>
                <el-table-column prop="link"
                                 show-overflow-tooltip
                                 label="链接">
                    <template slot-scope="scope">
                        <span>{{scope.row.link}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作"
                                 width="80">
                    <template slot-scope="scope">
                        <span class="table-btn"
                              @click="initRow(scope.row)">初始化</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="page"
                           :page-sizes="pageSizes"
                           :page-size="page_size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
        <el-dialog title="上传"
                   :visible.sync="upVisible"
                   :close-on-click-modal="false"
                   :before-close="beforeClose"
                   width="1000px">
            <el-form ref="form"
                     class="my-form"
                     :model="form"
                     :rules="rule"
                     hide-required-asterisk
                     size="mini"
                     label-position="top">
                <el-form-item label="书本名称"
                              prop="book_name">
                    <el-input v-model="form.book_name"
                              clearable
                              placeholder="请输入书本名称"></el-input>
                </el-form-item>
                <el-form-item label="码库文件"
                              prop="excle_file">
                    <el-upload ref="upload"
                               v-if="upVisible"
                               action="#"
                               multiple
                               class="upload_test_btn"
                               :on-change="fileChange"
                               :on-remove="fileRemove"
                               :auto-upload="false"
                               :file-list="fileList">
                        <el-button slot="trigger"
                                   type="primary">点击上传</el-button>
                        <span>{{file_name}}</span>
                    </el-upload>
                </el-form-item>
                <el-form-item label="正版购买地址"
                              prop="img_file">
                    <el-upload ref="upload"
                               v-if="upVisible"
                               action="#"
                               class="avatar-uploader"
                               :on-change="imgChange"
                               :show-file-list="false"
                               :auto-upload="false">
                        <img v-if="imageUrl"
                             :src="imageUrl"
                             class="avatar">
                        <i v-else
                           class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item prop="unuse_pass"
                              label-width="100%"
                              label-position="top">
                    <div slot="label"
                         class="form_label">
                        <span>验证结果提示：（未验证过验证码，验证通过） 自定义：</span>
                        <el-switch v-model="form.is_unuse_pass"></el-switch>
                    </div>
                    <el-input type="textarea"
                              :rows="3"
                              v-if="form.is_unuse_pass"
                              v-model="form.unuse_pass"></el-input>
                </el-form-item>
                <el-form-item prop="used_pass"
                              label-width="100%"
                              label-position="top">
                    <div slot="label"
                         class="form_label">
                        <span>验证结果提示：（已验证过验证码，手机号、微信ID验证通过） 自定义：</span>
                        <el-switch v-model="form.is_used_pass"></el-switch>
                    </div>
                    <el-input type="textarea"
                              :rows="3"
                              v-if="form.is_used_pass"
                              v-model="form.used_pass"></el-input>
                </el-form-item>
                <el-form-item prop="phone_fail"
                              label-width="100%"
                              label-position="top">
                    <div slot="label"
                         class="form_label">
                        <span>验证结果提示：（手机号验证不通过） 自定义：</span>
                        <el-switch v-model="form.is_phone_fail"></el-switch>
                    </div>
                    <el-input type="textarea"
                              :rows="3"
                              v-if="form.is_phone_fail"
                              v-model="form.phone_fail"></el-input>
                </el-form-item>
                <el-form-item prop="wechat_account_fail"
                              label-width="100%"
                              label-position="top">
                    <div slot="label"
                         class="form_label">
                        <span>验证结果提示：（微信ID验证不通过） 自定义：</span>
                        <el-switch v-model="form.is_wechat_account_fail"></el-switch>
                    </div>
                    <el-input type="textarea"
                              :rows="3"
                              v-if="form.is_wechat_account_fail"
                              v-model="form.wechat_account_fail"></el-input>
                </el-form-item>
                <el-form-item prop="check_fail"
                              label-width="100%"
                              label-position="top">
                    <div slot="label"
                         class="form_label">
                        <span>验证结果提示：（验证码不存在） 自定义：</span>
                        <el-switch v-model="form.is_check_fail"></el-switch>
                    </div>
                    <el-input type="textarea"
                              :rows="3"
                              v-if="form.is_check_fail"
                              v-model="form.check_fail"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="upVisible = false">取 消</el-button>
                <el-button type="primary"
                           :loading="upLoading"
                           @click="submit">提 交</el-button>
            </span>
        </el-dialog>
        <el-dialog title="统计"
                   :visible.sync="statisticsDialog"
                   :close-on-click-modal="false"
                   width="1000px">
            <el-table
                :data="statisticsData"
                border
                size="mini"
                style="width: 100%">
            <el-table-column
                prop="book_name"
                label="书本名称">
            </el-table-column>
            <el-table-column
                prop="is_used"
                label="已使用">
            </el-table-column>
            <el-table-column
                prop="un_used"
                label="未使用">
            </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import operationMixin from '@/assets/js/operation-mixin.js'
    import homeServer from '@/api/home-server.js'
    const emptyFormModel = (item) => {
        return {
            book_name: '',
            unuse_pass: '正版验证通过！感谢您使用正版图书！该产品为爱疯大课堂的正版教辅教材，品质保证，请放心使用。可点击下面链接领取本书配套课程兑换券，进入爱疯大课堂学习。集体订购或其他任何问题，可致电：13825163099  或加微信：Aqiu898。',
            used_pass: '此验证码你已在X年X月X日X点X分验证通过，如还没领取配套课程，请尽快点击下面链接领取本书配套课程兑换券，进入爱疯大课堂学习。如已领取，请忽略。集体订购或其他任何问题，可致电：13825163099  或加微信：Aqiu898。',
            phone_fail: '您所查询的验证码已被多次查询，如你是首次刮开验证，那么你买的是盗版盗印图书！如非首次查询，请用当时验证的微信和手机查询！拒绝盗版，请支持正版！除本公司官方网店外，本书没有授权任何淘宝、京东、拼多多、当当等平台网店销售，但凡这些平台购买的，皆是盗版盗印，请向卖家索偿并向平台举报！我们保留追究相关违法责任的权利！扫码可购买正版图书！享受优质配套课程及服务！集体订购请联系13825163099。',
            wechat_account_fail: '您所查询的验证码已被多次查询，如你是首次刮开验证，那么你买的是盗版盗印图书！如非首次查询，请用当时验证的微信和手机查询！拒绝盗版，请支持正版！除本公司官方网店外，本书没有授权任何淘宝、京东、拼多多、当当等平台网店销售，但凡这些平台购买的，皆是盗版盗印，请向卖家索偿并向平台举报！我们保留追究相关违法责任的权利！扫码可购买正版图书！享受优质配套课程及服务！集体订购请联系13825163099。',
            check_fail: '正版验证不通过，该验证码非法或盗版！拒绝盗版，请支持正版！除本公司官方网店外，本书没有授权任何淘宝、京东、拼多多、当当等平台网店销售，但凡这些平台购买的，请向卖家索偿并向平台举报！我们保留追究相关违法责任的权利！扫码可购买正版图书！享受优质配套课程及服务！集体订购请联系13825163099。',
            is_unuse_pass: false,
            is_used_pass: false,
            is_phone_fail: false,
            is_wechat_account_fail: false,
            is_check_fail: false,
            ...(item ? item : {}),
        }
    }
    export default {
        data() {
            let validateExcleFile = (rule, value, callback) => {
                if (this.fileList && this.fileList.length > 0) {
                    callback()
                } else {
                    callback(new Error('请上传码库文件'))
                }
            }
            let validateImgFile = (rule, value, callback) => {
                if (this.imgFlie) {
                    callback()
                } else {
                    callback(new Error('请上传正版购买二维码'))
                }
            }
            return {
                formSearch: {
                    book_name: '',
                    check_code: '',
                    isused: '',
                    phone: ''
                },
                options: [{
                    value: '已使用',
                    label: '已使用',
                },{
                    value: '未使用',
                    label: '未使用',
                }],
                upVisible: false,
                upLoading: false,
                file_name: '',
                tableData: [],
                loading: false,
                upForm: null,
                fileList: [],
                imgFlie: null,
                imageUrl: '',
                rule: {
                    excle_file: [{ validator: validateExcleFile }],
                    img_file: [{ validator: validateImgFile }],
                    book_name: [{ required: true, message: '请填写书本名称', trigger: 'blur' }],
                    unuse_pass: [{ required: true, message: '请填写验证结果提示', trigger: 'blur' }],
                    used_pass: [{ required: true, message: '请填写验证结果提示', trigger: 'blur' }],
                    phone_fail: [{ required: true, message: '请填写验证结果提示', trigger: 'blur' }],
                    wechat_account_fail: [{ required: true, message: '请填写验证结果提示', trigger: 'blur' }],
                    check_fail: [{ required: true, message: '请填写验证结果提示', trigger: 'blur' }],
                },
                form: emptyFormModel(),
                statisticsData: [],
                statisticsDialog: false
            }
        },
        mixins: [operationMixin],
        mounted() {
            this.search(1)
        },
        methods: {
            initRow(row) {
                this.$confirm('是否确认初始化?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let req = {
                        check_code: row.code
                    }
                    homeServer.initCode(req).then(res => {
                        this.search()
                    })
                }).catch(() => { })
            },
            submit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.upLoading = true
                        let formData = new FormData()
                        this.fileList.forEach((item) => {
                            formData.append('file', item.raw)
                        })
                        formData.append('file', this.imgFlie.raw)
                        formData.append('unuse_pass', this.form.is_unuse_pass ? this.form.unuse_pass : '')
                        formData.append('used_pass', this.form.is_used_pass ? this.form.used_pass : '')
                        formData.append('phone_fail', this.form.is_phone_fail ? this.form.phone_fail : '')
                        formData.append('wechat_account_fail', this.form.is_wechat_account_fail ? this.form.wechat_account_fail : '')
                        formData.append('check_fail', this.form.is_check_fail ? this.form.check_fail : '')
                        formData.append('book_name', this.form.book_name ? this.form.book_name : '')
                        console.log(formData)
                        homeServer.uploadExcel(formData).then(res => {
                            this.upLoading = false
                            if (res.code == 200) {
                                this.$message.success('上传成功')
                                this.upVisible = false
                                this.search(1)
                            } else if (res.code == 400) {
                                this.$message.error('参数错误')
                            } else {
                                this.$message.error('上传失败')
                            }
                        })
                        setTimeout(() => {
                            this.upLoading = false
                        }, 20000)
                    } else {
                        return false
                    }
                })
                // if (this.fileList && this.fileList.length > 0) {
                //     this.upLoading = true
                //     this.$refs.upload.submit()

                //     // let promiseList = []
                //     // this.fileList.forEach((item) => {
                //     //     let formData = new FormData()
                //     //     formData.append('file', item.raw)
                //     //     promiseList.push(homeServer.uploadExcel(formData))
                //     // })
                //     // this.upLoading = true
                //     // Promise.all(promiseList).then((values) => {
                //     //     this.upLoading = false

                //     // })
                // } else {
                //     this.$message.warning('请上传码库文件')
                // }
            },
            fileChange(file, fileList) {
                let index = file.name.lastIndexOf('.')
                let suffix = file.name.substr(index + 1)
                let isExcle = suffix === 'xlsx' || suffix === 'xls'
                if (!isExcle) {
                    this.$message.warning('请上传xlsx、xls格式的文件!')
                    fileList.pop()
                    return
                }
                this.fileList = fileList
            },
            fileRemove(file, fileList) {
                this.fileList = fileList
            },
            // fileSuccess(response, file, fileList) {
            //     let upFinish = true
            //     let upSuccess = true
            //     fileList.forEach((item) => {
            //         if (item.percentage !== 100) {
            //             upFinish = false
            //             if (item.response && item.response.code !== 200) {
            //                 upSuccess = false
            //                 this.$message.error(item.response.message)
            //             }
            //         }
            //     })
            //     if (upFinish && upSuccess) {
            //         this.$message.success('上传成功')
            //         this.upLoading = false
            //         this.upVisible = false
            //         this.search(1)
            //     }
            // },
            imgChange(file, fileList) {
                let index = file.name.lastIndexOf('.')
                let suffix = file.name.substr(index + 1)
                let isImg = suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg'
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isImg) {
                    return this.$message.error('请上传图片格式格式!');
                }
                if (!isLt2M) {
                    return this.$message.error('上传二维码大小不能超过 5MB!');
                }
                this.imageUrl = URL.createObjectURL(file.raw);
                this.imgFlie = file
                console.log(this.imageUrl)
            },
            search(page) {
                if (page) {
                    this.page = page
                }
                let req = {
                    page: this.page,
                    page_size: this.page_size,
                }
                req = Object.assign(req, this.formSearch)
                this.loading = true
                homeServer.getCodeList(req).then(res => {
                    this.loading = false
                    if (res.code === 200) {
                        this.tableData = res.data.data
                        this.total = res.data.total
                        this.statisticsData = []
                        for(let key in res.data.un_used) {
                            this.statisticsData.push({
                                book_name: key,
                                is_used: res.data.is_used[key],
                                un_used: res.data.un_used[key]
                            })
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            add() {
                this.fileList = []
                this.imgFlie = null
                this.imageUrl = ''
                this.form = emptyFormModel()
                this.upLoading = false
                this.upVisible = true
            },
            beforeClose() {
                this.fileList = []
                this.$refs.upload.clearFiles()
                this.upVisible = false
            },
            reset() {
                this.formSearch = {
                    check_code: '',
                    phone: ''
                }
                this.$nextTick(() => {
                    this.search(1)
                })
            },
        }
    }
</script>

<style lang="less">
    #home {
        .my-form {
            .el-form-item__label {
                width: 100%;
            }
            .form_label {
                line-height: 40px;
                .el-switch {
                    height: 40px;
                    line-height: 40px;
                }
            }
            .el-textarea__inner {
                resize: none;
                font-family: "Microsoft YaHei";
            }
            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .avatar-uploader .el-upload:hover {
                border-color: #409eff;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .avatar {
                width: 100px;
                height: 100px;
                display: block;
            }
        }
    }
</style>